var _circle, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTradingCardsLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    fill: "none",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 49.5,
    fill: "#fff",
    stroke: "#E5E8EB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1868B7",
    d: "M35 30C35 28.3431 36.3431 27 38 27H70C71.6569 27 73 28.3431 73 30V78C73 79.6568 71.6569 81 70 81H38C36.3431 81 35 79.6569 35 78V30Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2BCDE4",
    d: "M27 22C27 20.3431 28.3431 19 30 19H62C63.6569 19 65 20.3431 65 22V70C65 71.6568 63.6569 73 62 73H30C28.3431 73 27 71.6569 27 70V22Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#1868B7",
    d: "M32 26C32 24.8954 32.8954 24 34 24H58C59.1046 24 60 24.8954 60 26V52C60 53.1046 59.1046 54 58 54H34C32.8954 54 32 53.1046 32 52V26Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#1868B7",
    d: "M32 62.5C32 60.567 33.567 59 35.5 59H45.5C47.433 59 49 60.567 49 62.5C49 64.433 47.433 66 45.5 66H35.5C33.567 66 32 64.433 32 62.5Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTradingCardsLight);
export default __webpack_public_path__ + "static/media/trading-cards-light.6148d762991d0618bf26be13e0410db2.svg";
export { ForwardRef as ReactComponent };